// extracted by mini-css-extract-plugin
export var checkbox = "_6a-0";
export var circle = "_6a-3";
export var horizontalContainer = "_6a-7";
export var sm = "_6a-5";
export var switch0 = "_6a-2";
export var switchDisabled = "_6a-8";
export var switchEnabled = "_6a-1";
export var textSwitchContainer = "_6a-9";
export var textSwitchOption = "_6a-a";
export var textSwitchOptionSelected = "_6a-b";
export var verticalContainer = "_6a-6";
export var xs = "_6a-4";